import { Button, Table } from "antd";
import { FinanceEntryType } from "../typeDefs";

const money = (value: number) => `$${value.toFixed(2)}`;

const calculateCurrentValue = (entry: FinanceEntryType) => {
  const rate = entry.depreciationRate || 0;
  const years = Math.max(
    0,
    new Date().getFullYear() - new Date(entry.date).getFullYear(),
  );

  if (entry.amount < 1000) return 0;

  if (entry.depreciationMethod === "Diminishing Value") {
    let value = entry.amount;
    for (let i = 0; i < years; i += 1) value -= value * (rate / 100);
    return Math.max(0, value);
  }

  return Math.max(0, entry.amount - entry.amount * (rate / 100) * years);
};

export const AssetRegister = ({ data }: { data: FinanceEntryType[] }) => {
  const assets = data.filter((item) => !item.isDeleted && item.category === "Assets");
  const totalCost = assets.reduce((total, item) => total + item.amount, 0);
  const bookValue = assets.reduce((total, item) => total + calculateCurrentValue(item), 0);
  const depreciation = totalCost - bookValue;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 24, fontWeight: "bold" }}>
        <div>Total asset cost: {money(totalCost)}</div>
        <div>Current book value: {money(bookValue)}</div>
        <div>Estimated depreciation: {money(depreciation)}</div>
      </div>

      <Button onClick={() => window.print()}>Print Asset Register</Button>

      <Table
        size="small"
        pagination={{ pageSize: 10 }}
        dataSource={assets.map((item) => ({ ...item, key: item.id }))}
        columns={[
          { title: "Purchase Date", dataIndex: "date", render: (value) => new Date(value).toLocaleDateString("en-GB") },
          { title: "Asset", dataIndex: "description" },
          { title: "Supplier", dataIndex: "vendor" },
          { title: "Category", dataIndex: "subCategory" },
          { title: "Cost", dataIndex: "amount", render: money },
          { title: "Method", dataIndex: "depreciationMethod", render: (value) => value || "Straight Line" },
          { title: "Rate", dataIndex: "depreciationRate", render: (value) => `${value || 0}%` },
          { title: "Book Value", render: (_value, record) => money(calculateCurrentValue(record)) },
          { title: "Receipt", dataIndex: "receipt", render: (value) => (value ? "Yes" : "No") },
        ]}
      />
    </div>
  );
};
